module.exports = __webpack_public_path__ + "28b67065/img/arrow-share-icon.00a12c29.svg";